import { css } from '@repo/pandacss/css';

// `:has(:focus-visible)` lights up the label when the visually-hidden input inside has
// keyboard focus, since the input itself is offscreen.
export const optionCardClass = css({
  display: 'flex',
  alignItems: 'center',
  gap: '3',
  p: '3',
  rounded: 'md',
  border: '[1px solid {colors.neutral.lighter}]',
  bg: 'common.white',
  cursor: 'pointer',
  transition: '[border-color 150ms, background-color 150ms]',
  width: '[100%]',
  textAlign: 'left',
  color: 'neutral.darkest',
  textStyle: 'body',
  lineHeight: 'body',
  position: 'relative',
  _hover: { borderColor: 'blues.focus' },
  '&:has(:focus-visible)': {
    outline: '[2px solid {colors.blues.focus}]',
    outlineOffset: '[-2px]',
  },
});

export const optionCardSelectedStyles = css({
  borderColor: 'blues.focus',
  bg: 'blues.lightest',
});

export const optionCardDisabledStyles = css({
  opacity: '[0.5]',
  cursor: 'not-allowed',
  _hover: { borderColor: 'neutral.lighter' },
});
